export default {
  res_help_title: "Restaurant Help & Support",
  res_help_subtitle: "Manage your restaurant operations smoothly",

  res_profile_title: "Complete Restaurant Profile",
  res_profile_desc: "Update your restaurant details",
  res_go_profile: "Go to Profile",

  res_dashboard_tour: "Dashboard Tour",
  res_dashboard_tour_desc: "Learn dashboard features",
  res_start_tour: "Start Tour",

  res_tools_title: "Restaurant Tools",
  res_tools_desc: "Manage tools and reports",
  res_explore_tools: "Explore Tools",

  res_docs_title: "Documentation",
  res_docs_desc: "Read full documentation",
  res_view_docs: "View Docs",

  res_support_title: "Need Support?",
  res_support_desc: "We are here to help",
  res_contact_support: "Contact Support"
};